import { useCallback, useRef, useState } from "react";
import { useTranslation } from "../context/TranslationContext";
import Avatar from "./ds/Avatar";
import Icon from "./ds/Icon";
import IconButton from "./ds/IconButton";
import NavDropdown from "./ds/NavDropdown";

/*
  Figma "Space bar · სივრცის ზოლი": phones and tablets reach a space's pages from this bar
  instead of the sidebar. Back, then the space and the page you are on; tapping those opens
  the same menu, in two columns on a tablet and one on a phone. `groups` are the menu's
  columns, `alert` marks the bar while something in the closed menu is waiting.
*/
const SpaceBar = ({ space, current, groups, alert = false, isDark, onBack }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const barRef = useRef(null);
  const close = useCallback(() => setOpen(false), []);

  return (
    <div className="px-space-8 pb-[6px] pt-[6px] min-[600px]:px-space-12 lg:hidden">
      <div
        ref={barRef}
        className={`flex min-h-[58px] items-center gap-[10px] rounded-radius-lg bg-bg-raised px-space-12 py-space-8 ${
          open ? "shadow-[inset_0_0_0_1px_var(--color-accent-default)]" : ""
        }`}
      >
        <IconButton label={t("common.back")} variant="plain" onClick={onBack}>
          <Icon name="arrow-left" size={18} />
        </IconButton>
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
          className="flex min-w-0 flex-1 items-center gap-[10px] rounded-radius-md text-left outline-none focus-visible:shadow-[0_0_0_2px_var(--color-focus-ring)]"
        >
          <Avatar size="m" src={space?.logo} name={space?.name} />
          <span className="flex min-w-0 flex-1 flex-col">
            <span className="truncate text-subheadline-semibold text-label-primary">{space?.name}</span>
            <span className="truncate text-footnote text-label-secondary">{current}</span>
          </span>
          {alert && <span className="size-2 shrink-0 rounded-full bg-status-danger" aria-hidden="true" />}
          <Icon name={open ? "chevron-up" : "chevron-down"} size={20} className="text-label-secondary" />
        </button>
      </div>
      {open && (
        <NavDropdown anchorRef={barRef} isDark={isDark} maxHeight={614} onClose={close}>
          <div className={`grid grid-cols-1 gap-space-16 ${groups.length > 1 ? "min-[600px]:grid-cols-2" : ""}`}>
            {groups.map((group) => (
              <div key={group.label} className="flex min-w-0 flex-col">
                <p className="mb-[6px] text-caps-group uppercase text-label-secondary">{group.label}</p>
                {group.items}
              </div>
            ))}
          </div>
        </NavDropdown>
      )}
    </div>
  );
};

export default SpaceBar;
